import instanceAxios from '@/util/axios';
import { aiChatActionUrl } from '@/constants';
import { CrmChatActionRequest, CrmChatActionResponse } from './chatAction.types';

/** Executes a chat write action the user approved in the UI. */
export const executeCrmChatAction = async (request: CrmChatActionRequest): Promise<CrmChatActionResponse> => {
  const { data } = await instanceAxios.post<CrmChatActionResponse>(aiChatActionUrl, request);
  return data;
};
